import {URLUtils} from "@webfruits/toolbox/dist/utils/URLUtils";

/******************************************************************
 * AppConfig
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class AppConfig {

    /* ----------------------------------------------------------------
 	 * ANIMATIONS
 	 * --------------------------------------------------------------*/

    static readonly HOTSPOT_HOVER_DURATION = 0.3;
    static readonly HOTSPOT_SELECT_DURATION = 0.7;

    /* ----------------------------------------------------------------
 	 * APPEARENCE
 	 * --------------------------------------------------------------*/

    static readonly USE_FACT_FOR_INFO = true;
    static readonly FACT_INFO_SHOW_DELAY = 0.6;
    static readonly MIN_HOTSPOT_SCALE = 1.2;
    static readonly MAX_HOTSPOT_SCALE = 1.5;

    /* ----------------------------------------------------------------
 	 * LANGUAGE
 	 * --------------------------------------------------------------*/

    static get LANGUAGE_CODE(): string {
        return URLUtils.getUrlParam("lang", "en");
    }

}
